"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _nicbaseTranslation = require("nicbase-translation");

require("./no-data-message.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NoDataMessage = function NoDataMessage() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "noDataMessage"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "noDataMessage-Content"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "noDataMessage-Message"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.latestData.nodata.message",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "noDataMessage-Reasons"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "noDataMessage-ReasonsParagraph"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.latestData.nodata.reasons",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "noDataMessage-ReasonsList"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    tagName: "li",
    id: "widgets.latestData.nodata.reasonOne"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    tagName: "li",
    id: "widgets.latestData.nodata.reasonTwo"
  })))));
};

var _default = NoDataMessage;
exports["default"] = _default;